import {Component, OnDestroy, OnInit} from '@angular/core';
import {Login} from '../../modelo/usuario/login';
import {UserloginService} from '../../servicios/usuario/userlogin.service';
import {SubscriptionLike} from 'rxjs';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.css']
})
export class ProductoComponent implements OnInit,OnDestroy {

  public currentUser: Login;
  private subs:SubscriptionLike[];


  constructor(private userLogin:UserloginService) {
    this.currentUser=null;
    this.subs=[];
  }

  ngOnInit() {
    this.subs.push(
    this.userLogin.currentUser.subscribe(res=>{
      this.currentUser=res;

    }))

  }

  isLoged() {
    return this.currentUser!=null;
  }

  ngOnDestroy(): void {
    this.subs.forEach(s=>s.unsubscribe());
  }
}
